import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import Layout from "./components/Layout";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";  // Eager-load home for instant first paint

// Code-split everything else — these only load when the user navigates to them.
// Saves ~70% off initial mobile bundle.
const Reservations = lazy(() => import("./pages/Reservations"));
const EventDetail = lazy(() => import("./pages/EventDetail"));
const Gallery = lazy(() => import("./pages/Gallery"));
const Experiences = lazy(() => import("./pages/Experiences"));
const PrivateEvents = lazy(() => import("./pages/PrivateEvents"));
const Membership = lazy(() => import("./pages/Membership"));
const Careers = lazy(() => import("./pages/Careers"));
const Contact = lazy(() => import("./pages/Contact"));
const BookingSuccess = lazy(() => import("./pages/BookingSuccess"));
const Checkout = lazy(() => import("./pages/Checkout"));
const AdminLogin = lazy(() => import("./pages/AdminLogin"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard"));
const AdminScan = lazy(() => import("./pages/AdminScan"));
const PromoterLogin = lazy(() => import("./pages/PromoterLogin"));
const PromoterDashboard = lazy(() => import("./pages/PromoterDashboard"));
const Account = lazy(() => import("./pages/Account"));
const Menu = lazy(() => import("./pages/Menu"));
const Embed = lazy(() => import("./pages/Embed"));
const Terms = lazy(() => import("./pages/Terms"));
const Privacy = lazy(() => import("./pages/Privacy"));
const TextUs = lazy(() => import("./pages/TextUs"));
const EcwidCheckout = lazy(() => import("./pages/EcwidCheckout"));

const Loading = () => (
  <div className="min-h-[60svh] flex items-center justify-center">
    <div className="w-10 h-10 rounded-full border-2 border-[#D4AF7A]/30 border-t-[#D4AF7A] animate-spin" />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/reservations" element={<Reservations />} />
            <Route path="/reservations/:slug" element={<Reservations />} />
            <Route path="/events" element={<Reservations />} />
            <Route path="/events/:slug" element={<EventDetail />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/experiences" element={<Experiences />} />
            <Route path="/private-events" element={<PrivateEvents />} />
            <Route path="/membership" element={<Membership />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/booking-success" element={<BookingSuccess />} />
            <Route path="/checkout/:reservationId" element={<Checkout />} />
            <Route path="/account" element={<Account />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/text-us" element={<TextUs />} />
          </Route>
          {/* Ecwid checkout — full-screen, no site chrome; Ecwid widget takes over */}
          <Route path="/checkout-ecwid" element={<EcwidCheckout />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/scan" element={<AdminScan />} />
          <Route path="/admin/scan/:code" element={<AdminScan />} />
          <Route path="/promoter/login" element={<PromoterLogin />} />
          <Route path="/promoter" element={<PromoterDashboard />} />
          {/* Embed routes — no Layout wrapper (no nav/footer) so the section renders
              naked inside an iframe on Duda / Wix / Squarespace / etc. */}
          <Route path="/embed/:section" element={<Embed />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
